import { render, staticRenderFns } from "./CompetencesStep.vue?vue&type=template&id=5f48bc33&"
import script from "./CompetencesStep.vue?vue&type=script&lang=js&"
export * from "./CompetencesStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports